import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import useReactApexChart from "../../hook/useReactApexChart";

const UnitCountTwo = ({
  CustomerTotal,
  total_reviews_new_customer_data_late,
  total_reviews_new_customer_data,
  total_customer,
  total_new_customer,
  total_click_type,
  total_customer_positive,
  total_new_customer_negative,
  total_new_customer_negative_last,
  total_customer_positive_last,
}) => {
  let { createChart } = useReactApexChart();

  return (
    <div className="col-lg-12">
      <div className="row gy-4">
        <div className="col-lg-4 col-md-6 col-12">
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                    <Icon icon="mingcute:user-follow-fill" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Total Customers
                    </span>
                    <h6 className="fw-semibold">{total_customer}</h6>
                  </div>
                </div>
                <div
                  id="new-user-chart"
                  className="remove-tooltip-title rounded-tooltip-value"
                >
                  {createChart("#487fff")}
                </div>
              </div>
              <p className="text-sm mb-0">
                {(() => {
                  const total_reviews_arreow =
                    parseInt(total_customer_positive) -
                    parseInt(total_customer_positive_last);
                  return total_reviews_arreow > 0 ? (
                    <span className="d-inline-flex align-items-center gap-1 text-success-main">
                      <Icon icon="bxs:up-arrow" className="text-xs" />
                      {total_reviews_arreow}
                    </span>
                  ) : (
                    <span className="d-inline-flex align-items-center gap-1 text-danger-main">
                      <Icon icon="bxs:down-arrow" className="text-xs" />
                      {total_reviews_arreow}
                    </span>
                  );
                })()}
                {"  "}Last {total_click_type}
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="mingcute:user-follow-fill" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      New Customers
                    </span>
                    <h6 className="fw-semibold">{total_new_customer}</h6>
                  </div>
                </div>
                <div
                  id="active-user-chart"
                  className="remove-tooltip-title rounded-tooltip-value"
                >
                  {/* Pass the color value here */}
                  {createChart("#45b369")}
                </div>
              </div>
              <p className="text-sm mb-0">
                {(() => {
                  const total_reviews_arreow =
                    parseInt(total_new_customer_negative) -
                    parseInt(total_new_customer_negative_last);
                  return total_reviews_arreow > 0 ? (
                    <span className="d-inline-flex align-items-center gap-1 text-success-main">
                      <Icon icon="bxs:up-arrow" className="text-xs" />
                      {total_reviews_arreow}
                    </span>
                  ) : (
                    <span className="d-inline-flex align-items-center gap-1 text-danger-main">
                      <Icon icon="bxs:down-arrow" className="text-xs" />
                      {total_reviews_arreow}
                    </span>
                  );
                })()}
                {"  "}Last {total_click_type}
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-5">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-pink text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="mdi:leads" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Recurring Customers
                    </span>
                    <h6 className="fw-semibold">
                      {total_reviews_new_customer_data}
                    </h6>
                  </div>
                </div>
                <div
                  id="leads-chart"
                  className="remove-tooltip-title rounded-tooltip-value"
                >
                  {/* Pass the color value here */}
                  {createChart("#de3ace")}
                </div>
              </div>
              <p className="text-sm mb-0">
                {(() => {
                  const total_reviews_arreow =
                    parseInt(total_reviews_new_customer_data) -
                    parseInt(total_reviews_new_customer_data_late);
                  return total_reviews_arreow > 0 ? (
                    <span className="d-inline-flex align-items-center gap-1 text-success-main">
                      <Icon icon="bxs:up-arrow" className="text-xs" />
                      {total_reviews_arreow}
                    </span>
                  ) : (
                    <span className="d-inline-flex align-items-center gap-1 text-danger-main">
                      <Icon icon="bxs:down-arrow" className="text-xs" />
                      {total_reviews_arreow}
                    </span>
                  );
                })()}
                {"  "}Last {total_click_type}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitCountTwo;
